// extracted by mini-css-extract-plugin
module.exports = {"container":"Trending_container__3glrN","scale":"Trending_scale__8fsr0"};